<template>
    <div class="min-h-screen bg-surface-muted">
        <div class="flex min-h-screen">
            <section class="relative flex min-h-screen basis-full flex-col bg-white lg:basis-1/2">
                <div class="flex flex-1 min-h-0 items-center overflow-y-auto px-8 py-12">
                    <div class="mx-auto w-full max-w-[28rem]">
                        <div>
                            <h1 class="text-4xl font-semibold text-gray-900">{{ $t('This page could not be found') }}</h1>
                            <p class="mt-4 text-[0.95rem] leading-[1.6] text-ink">
                                {{ $t('The page you requested is currently unavailable or no longer exists.') }}
                            </p>
                        </div>
                        <div class="mt-10">
                            <router-link
                                active-class=""
                                class="btn-stage-primary min-h-[3rem] justify-center !px-12"
                                exact-active-class=""
                                to="/"
                            >
                                {{ $t('Go home') }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="shrink-0 bg-white px-8 pb-14 pt-10">
                    <div class="mx-auto flex w-full max-w-[28rem] items-end min-h-[5.5rem]">
                        <legal-links-menu
                            link-class="text-[0.95rem] font-normal leading-[1.6] text-ink-muted no-underline hover:text-ink"
                            wrapper-class="flex flex-wrap gap-x-4 gap-y-2 text-[0.95rem] leading-[1.6] text-ink-muted"
                        />
                    </div>
                </div>
            </section>
            <aside class="relative hidden min-h-screen overflow-hidden bg-[#202830] bg-cover bg-center bg-no-repeat lg:block lg:basis-1/2" :style="visualPanelStyle">
                <div class="auth-shell__visual-overlay absolute inset-0"></div>
                <div class="relative z-[1] flex h-full flex-col p-14 text-white">
                    <img :src="visualLogo" :alt="$store.state.settings.name" class="block h-7 w-auto self-start object-contain">
                    <div class="mt-auto max-w-[30rem]">
                        <img :src="visualMark" :alt="$store.state.settings.name" class="w-16 h-16 -ml-3 object-contain">
                        <p class="mt-4 text-base leading-relaxed text-white/80" v-html="visualText"></p>
                    </div>
                </div>
            </aside>
        </div>
    </div>
</template>

<script>
import LegalLinksMenu from "@/components/shared/legal-links-menu";

export default {
    name: "not-found",
    components: {LegalLinksMenu},
    metaInfo() {
        return {
            title: this.$i18n.t('Not found')
        }
    },
    computed: {
        visualPanelStyle() {
            const backgroundImage = this.$store.state.settings.background;
            const style = {};

            if (backgroundImage) {
                style.backgroundImage = 'url(' + backgroundImage + ')';
            }

            return style;
        },
        visualLogo() {
            return this.$store?.state?.settings?.logo_invert
                || this.$store?.state?.settings?.logo
                || '/images/default/logo_invert.svg';
        },
        visualMark() {
            return this.$store?.state?.settings?.logo_toggle_invert
                || this.$store?.state?.settings?.logo_toggle
                || '/images/default/icon.png';
        },
        visualText() {
            return 'CORPRED<sup class="auth-registered-mark">&reg;</sup> entwickelt digitale Applikationen für effiziente Prozesse, klare Kommunikation und zukunftsweisende Arbeitsabläufe.';
        }
    }
}
</script>

<style lang="scss">
.auth-registered-mark {
    font-size: 0.52em;
    line-height: 0;
    vertical-align: super;
}

.auth-shell__visual-overlay {
    background:
        linear-gradient(145deg, rgba(32, 40, 48, 0.8), rgba(20, 25, 31, 0.9)),
        linear-gradient(180deg, rgba(32, 40, 48, 0.15), rgba(20, 25, 31, 0.62));
}
</style>
